<template>
	<div class="doc-list-page">
		<!-- 查询区域 -->
		<el-form :inline="true" class="search-form">
			<el-form-item label="关键字">
				<el-input v-model="keyword" placeholder="请输入标题关键字" @blur="handleKeywordBlur"
					@keyup.enter="handleSearch"></el-input>
			</el-form-item>
			<el-form-item label="文档类型">
				<el-select v-model="docType" placeholder="全部类型" clearable @change="handleTypeChange">
					<el-option v-for="item in docTypeOptions" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
			</el-form-item>
		</el-form>
		<!-- 表格列表 -->
		<el-table :data="tableData" border stripe style="width:100%">
			<el-table-column label="序号" width="80">
				<template slot-scope="scope">
					{{ getRowIndex(scope.$index) }}
				</template>
			</el-table-column>
			<el-table-column prop="name" label="标题名称" min-width="220"></el-table-column>
			<el-table-column prop="publishTime" label="发布时间" width="120">
				<template slot-scope="scope">
					{{ formatTimestamp(scope.row.publishTime) }}
				</template>
			</el-table-column>
			<el-table-column prop="docType" label="类型" width="140">
				<template slot-scope="scope">
					{{ getDocTypeName(scope.row.docType) }}
				</template>
			</el-table-column>
			<el-table-column label="操作" width="140">
				<template slot-scope="scope">
					<el-button @click="forFaqText(scope.row)" type="text">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination class="pagination-wrap" @current-change="handleCurrentChange" :current-page="pageNum"
			:page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
		<el-dialog
		  :title="form.title"
		  :visible.sync="istextCount"
		  width="60%"
		  :close-on-click-modal="false"
		  :close-on-press-escape="false"
		  center
		  :append-to-body="true"
		  :z-Index="3200"
		>
		  
		  <div 
		    v-html="form.textCount" 
		    style="max-height:60vh;overflow-y:auto;"
		  ></div>
		  <el-button type="primary" @click="istextCount=false" style="margin-left:50%;align-items: center;">关闭</el-button>
		</el-dialog>

	</div>
</template>
<script>
	export default {
		name: "DocList",
		data() {
			return {
				// 查询条件
				keyword: "",
				docType: null,
				pageNum: 1,
				pageSize: 10,
				// 保存上一次的搜索关键字，用于blur对比
				lastKeyword: "",
				total: 0,
				tableData: [],
				// 文档类型下拉选项，自行替换业务值
				docTypeOptions: [{
						label: "帮助文档",
						value: "FAQ"
					},
					{
						label: "发版说明",
						value: "Release"
					}
				],

				login: null,
				istextCount: false,
				form: {
					title: '',
					textCount: ''
				}
			};
		},
		mounted() {
			this.fetchList();
		},
		methods: {
			async forFaqText(val) {
				this.form= {
					title:"",
					textCount:""
				}
				this.loginOpen('打开文档中...')
				try {
					let res = await this.API.get(this.API.fileurl.getNoticeDocContent + val.id)
					let content = res.data.data

					if (!content) return ''
					// 1. 创建虚拟DOM解析html字符串
					const parser = new DOMParser()
					const doc = parser.parseFromString(content, 'text/html')
					const imgList = Array.from(doc.querySelectorAll('img'))

					// 2. 循环所有img，收集异步签名任务
					const promiseTasks = imgList.map(async imgEl => {
						const originalSrc = imgEl.getAttribute('src')
						if (!originalSrc) return
						// 只处理oss相对路径（排除http开头已经是外网地址）
						if (originalSrc.startsWith('http')) return

						// await 获取oss签名下载url
						const signUrl = await this.$oss.getDownloadUrl(originalSrc)
						imgEl.setAttribute('src', signUrl)
					})

					// 等待全部图片签名完成
					await Promise.all(promiseTasks)

					// 获取处理之后完整html
					const handledHtml = doc.body.innerHTML

					this.form= {
						title:val.name,
						textCount: handledHtml
					}
					this.istextCount = true
					// 这里handledHtml就是全部图片src已经替换成签名url的html，赋值给编辑器

				} catch {

				} finally {
					this.noLogin()
				}
			},
			// 加载
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0,0,0,0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close();
					this.login = null;
				}
			},
			getRowIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1;
			},

			formatTimestamp(timestamp) {
				if (!timestamp) return "-";
				const date = new Date(timestamp);
				const y = date.getFullYear();
				const m = String(date.getMonth() + 1).padStart(2, "0");
				const d = String(date.getDate()).padStart(2, "0");
				return `${y}-${m}-${d}`;
			},
			getDocTypeName(val) {
				const find = this.docTypeOptions.find(opt => opt.value === val);
				return find ? find.label : val || "-";
			},
			handleTypeChange() {
				this.pageNum = 1;
				this.fetchList();
			},
			handleKeywordBlur() {
				if (this.keyword !== this.lastKeyword) {
					this.pageNum = 1;
					this.fetchList();
				}
			},

			// 查询
			handleSearch() {
				this.pageNum = 1;
				this.fetchList();
			},
			handleSizeChange(size) {
				this.pageSize = size;
				this.fetchList();
			},
			handleCurrentChange(page) {
				this.pageNum = page;
				this.fetchList();
			},
			async fetchList() {
				this.loginOpen('数据查询中...')
				try {
					// 更新上次关键字记录
					this.lastKeyword = this.keyword;
					let res = await this.API.get(this.API.fileurl.getNoticeFrontList, {
						pageNum: this.pageNum,
						pageSize: this.pageSize,
						docType: this.docType,
						name: this.keyword,
					})

					if (res?.data?.data?.records) {
						this.tableData = res.data.data.records || []
						this.total = res.data.data.total
					} else {
						this.tableData = []
						this.total = 0
					}

				} catch (err) {
					console.error(err);
				} finally {
					this.noLogin()
				}
			}
		}
	};
</script>
<style scoped>
	.search-form {
		margin-bottom: 16px;
	}

	.pagination-wrap {
		margin-top: 16px;
		text-align: right;
	}
</style>